import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import "./swagger-overrides.css";
import { authTokenManager } from "@legal-500/auth-client";
import * as api from "../../api/client";
import { UnauthorizedView } from "../../components/UnauthorizedView";
import { usePermissionKeys } from "../../contexts/AuthContext";
import styles from "./Swagger.module.css";

type SwaggerSystem = {
  authActions: {
    authorize: (auth: Record<string, unknown>) => void;
  };
};

function SwaggerPage() {
  const permissions = usePermissionKeys();

  const hasSwaggerAccess = permissions.includes("*") || permissions.includes("swagger:read");

  if (!hasSwaggerAccess) {
    return <UnauthorizedView />;
  }

  const requestInterceptor = (request: Record<string, unknown>): Record<string, unknown> => {
    const token = authTokenManager.getToken();
    if (token) {
      const headers = (request.headers as Record<string, string>) || {};
      return {
        ...request,
        headers: {
          ...headers,
          "X-L500-Token": token,
        },
      };
    }
    return request;
  };

  const onComplete = (system: SwaggerSystem) => {
    const token = authTokenManager.getToken();
    if (token) {
      system.authActions.authorize({
        l500Token: {
          name: "l500Token",
          schema: { type: "apiKey", in: "header", name: "X-L500-Token" },
          value: token,
        },
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      <SwaggerUI
        url={api.url("/swagger/openapi.json")}
        requestInterceptor={requestInterceptor}
        onComplete={onComplete}
      />
    </div>
  );
}

export default SwaggerPage;
